<template>
  <div>
    <el-table :data="paginatedData" border size="small">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="项目编号" width="180">
            <template slot-scope="scope">
              {{ scope.row.projectNumber }}
            </template>
        </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="tableData.length"
      style="margin-top: 10px; text-align: right;"
    />
  </div>
</template>

<script>
export default {
    name: 'business',
  computed: {
    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.tableData.slice(start, start + this.pageSize);
    }
  },
    data() {
        return {
            currentPage: 1,
            pageSize: 10,
            title: '工商信息',
            tableData: []
        }
    },
    methods: {
        handleCurrentChange(val) {
            this.currentPage = val;
        },
        getTableData() {
            this.tableData = [
                {
                    projectNumber: '2020-01-01-01'
                },
                {
                    projectNumber: '2020-01-01-02'
                },
                {
                    projectNumber: '2020-01-01-03'
                }
            ]
        }
    }
}
</script>

<style>

</style>